import { Check } from "lucide-react";
import { cn } from "@punchup/utils/cn";

interface StatusIndicatorProps {
  isComplete: boolean;
  isEmpty?: boolean; // New prop for optional fields that are empty (currently unused)
  className?: string;
}

export function StatusIndicator({
  isComplete,
  isEmpty = false,
  className,
}: StatusIndicatorProps) {
  // Only show green checkmark when complete, nothing otherwise
  if (!isComplete) {
    return null;
  }

  return (
    <div
      className={cn(
        "flex h-5 w-5 items-center justify-center rounded-full transition-colors bg-green-500",
        className
      )}
    >
      <Check className="h-3 w-3 text-white" strokeWidth={3} />
    </div>
  );
}
